var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{staticClass:"btn btn-link m-1",attrs:{"href":_vm.href}},[_vm._t("default"),_vm._v(" "),_c('span',{staticClass:"fas fa-edit mr-1"})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }